import { LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function RouteLoading() {
  const { t } = useTranslation("common");

  return (
    <div className="flex h-full min-h-0 w-full flex-1 items-center justify-center px-6 py-6">
      <div className="text-muted-foreground flex flex-col items-center gap-3 text-sm">
        <LoaderCircle className="text-primary size-5 animate-spin" />
        <span>{t("loading", { defaultValue: "Loading..." })}</span>
      </div>
    </div>
  );
}
